/**
* BranchInfo defines model for branch object information
*
* @typedef BranchInfo
* @type {Object}
* @property {id} BranchId identifier
* @property {name} BranchName of current branch ( translated )
* @property {code} Code of current branch as string
* @property {hasLiveEvents} Has live events flag
* @property {totalLiveCount} Number of live master events in the branch
* @property {handler} Event handler which should navigate to the branch page/panel
*/

export class BranchInfoModel {
    id: number;
    name: string;
    href: string;
    hasLiveEvents: boolean = false;
    totalLiveCount?: number = 0;
    handler: Function;

    constructor(branchData: BranchInfoModel) {
        this.id = branchData.id;
        this.name = branchData.name;
        this.href = branchData.href;
        this.hasLiveEvents = branchData.hasLiveEvents;
        this.totalLiveCount = branchData.totalLiveCount;
        this.handler = branchData.handler;
    }
}